/**
 *
 * LargeLabel
 *
 * Large variant for labels used by the Checkbox and Radio Button input components
 */
import React from 'react';
import classnames from 'classnames';
import Label from '../../../../atoms/Label';

var LargeLabel = function LargeLabel(_ref) {
  var extraClasses = _ref.extraClasses,
      htmlFor = _ref.htmlFor,
      label = _ref.label,
      variation = _ref.variation;
  return React.createElement(Label, {
    className: "".concat(variation, "__container"),
    htmlFor: htmlFor
  }, React.createElement("span", {
    className: "p"
  }, label), React.createElement("div", {
    className: classnames("".concat(variation, "__label"), "".concat(variation, "__label--button"), extraClasses)
  }));
};

LargeLabel.defaultProps = {
  extraClasses: ''
};
export default LargeLabel;